import React from 'react';
import cn from 'classnames';
import { CTALink } from "../../../../ui/CTA";
import { StoreIcon } from "../../../../ui/Icon";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import PopUp from '../PopUp';
import styles from './SeeSizes.module.scss';
const SeeSizes = ({ mySelectedStore, onClick, disabled, onClickEvents, labels, }) => {
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.innerContainer },
            React.createElement(StoreIcon, { className: styles.storeIcon, size: "small" }),
            React.createElement(BodyText, { ellipsis: true, className: cn(styles.someSizesLabel) }, labels === null || labels === void 0 ? void 0 :
                labels.fisLabel,
                " \u00A0",
                React.createElement("span", { className: styles.boldText }, mySelectedStore === null || mySelectedStore === void 0 ? void 0 : mySelectedStore.name)),
            React.createElement(PopUp, { popUpInfoText: labels === null || labels === void 0 ? void 0 : labels.fisPopUpText, popUpPosition: "top", onClickEvents: onClickEvents })),
        React.createElement(CTALink, { Tag: "button", className: cn(styles.seeSizesLink), onClick: onClick, disabled: disabled }, labels === null || labels === void 0 ? void 0 : labels.fisLinkText)));
};
export default SeeSizes;
//# sourceMappingURL=SeeSizes.js.map